<template>
  <div style="margin: 0 auto 5rem; max-width: 960px;">
    <div class="dashboard-title mb-xs">
      <BackButton
        :link="`/agency/our-public-profiles/leads/${this.$route.params.id}`"
        text="Back to Directory Leads"
      />
      <div style="display: flex; align-items: center;">
        <h1 class="fw-bold fs-xl">Directory Lead: {{ lead.companyName }}</h1>
        <div class="badge" :class="lead.status | statusClass">
          {{ lead.status | status }}
        </div>
      </div>
    </div>
    <div>
      <template>
        <Card v-if="leadFlowEnabled">
          <div class="grid">
            <div class="grid__cell col6-of-12--medium-up">
              <p class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs">
                project status:
              </p>
              <label
                :class="lead.status != 'A' ? 'is-disabled' : ''"
                style="margin-bottom: 0;"
              >
                <div class="select" style="margin: 0;">
                  <select
                    :disabled="lead.status != 'A'"
                    @change="handleProjectUpdate($event.target.value)"
                    class=""
                  >
                    <option :selected="!lead.projectStatus" value>-</option>
                    <option :selected="lead.projectStatus === 'N'" value="N"
                      >New lead</option
                    >
                    <option :selected="lead.projectStatus === 'C'" value="C"
                      >Lead contacted</option
                    >
                    <option :selected="lead.projectStatus === 'L'" value="L"
                      >Lead lost</option
                    >
                    <option :selected="lead.projectStatus === 'S'" value="S"
                      >Project secured</option
                    >
                  </select>
                </div>
              </label>
            </div>
          </div>
        </Card>
        <SectionHeading
          heading="Request details"
          description="Information submitted about the customer who needs services rendered"
        />
        <Card>
          <div class="grid">
            <div
              class="grid__cell col12-of-12--large-up"
              style="margin-bottom: 0;"
            >
              <div class="grid">
                <div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Request date:
                    </p>
                    <p class="fs-sm theme-text-medium">{{ dateSent }}</p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Client name:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ lead.companyName }}
                    </p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Contact person:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ lead.firstName + ' ' + lead.lastName }}
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ lead.email }}
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ lead.phone }}
                    </p>
                  </div>
                  <div
                    v-for="(item, i) in services"
                    :key="i"
                    class="grid__cell col4-of-12--large-up mb-sm"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      {{ item.filter_name }}:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ item.options | options }}
                    </p>
                  </div>
                  <div
                    class="grid__cell col12-of-12--large-up"
                    v-if="lead.comments"
                    style="margin-bottom: 0;"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      comments:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ lead.comments }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
        <div class="btn-section mt-md">
          <Button
            :disabled="!(lead.status === 'P' || lead.status === 'A')"
            type="button"
            bType="error"
            button-name="decline"
            v-on:button-click="
              handleUpdate('R');
              lead.projectStatus = null;
            "
            style="margin-right: 8px;"
          >
            {{
              !(lead.status === 'P' || lead.status === 'A')
                ? 'declined'
                : 'decline'
            }}
          </Button>
          <Button
            :disabled="!(lead.status === 'P' || lead.status === 'R')"
            type="button"
            button-name="accept"
            v-on:button-click="
              handleUpdate('A');
              lead.projectStatus = 'N';
            "
          >
            {{
              !(lead.status === 'P' || lead.status === 'R')
                ? 'accepted'
                : 'accept'
            }}
          </Button>
        </div>
      </template>
    </div>
    <div class="mb-lg" />
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
import SectionHeading from '@/components/DesignSystem/SectionHeading';
import Card from '@/components/DesignSystem/Card';
import BackButton from '@/components/BackButton';
const { mapGetters, mapActions } = createNamespacedHelpers(
  'ourPublicProfilesLeads'
);

export default {
  components: {
    Card,
    SectionHeading,
    Button,
    BackButton,
  },
  methods: {
    ...mapActions([
      'updateStatus',
      'updateProjectStatus',
      'fetchLeadsData',
      'setActiveLead',
    ]),
    handleUpdate(val) {
      this.updateStatus({ id: this.$route.params.leadId, status: val });
    },
    handleProjectUpdate(val) {
      this.updateProjectStatus({
        id: this.$route.params.leadId,
        projectStatus: val,
      });
    },
  },
  async created() {
    await this.$store.dispatch(
      'ourPublicProfilesDetail/fetchProfile',
      this.$route.params.id
    );
    await this.fetchLeadsData();
    this.setActiveLead(this.$route.params.leadId);
  },
  computed: {
    ...mapGetters(['lead']),
    dateSent() {
      return this.lead.created ? formatDate(new Date(this.lead.created)) : '';
    },
    services() {
      if (typeof this.lead.services !== 'string') return [];
      return JSON.parse(this.lead.services).filter(s => {
        if (s.filter_name) {
          let options = null;
          if (Array.isArray(s.options)) {
            options = s.options.length > 0 ? s.options : null;
          } else {
            options = s.options;
          }
          if (options) {
            s.options = options;
            return s;
          }
        }
      });
    },
    leadFlowEnabled() {
      return this.$store.getters['ourPublicProfilesDetail/profile']
        .leadFlowEnabled;
    },
  },
  filters: {
    options: function(value) {
      if (typeof value === 'string') {
        return value;
      }

      let string = '';
      value.forEach(item => {
        string += `${item}, `;
      });
      return string.slice(0, -2);
    },
    status(value) {
      switch (value) {
        case 'A':
          return 'Accepted';
        case 'R':
          return 'Declined';
        default:
          return 'Pending';
      }
    },
    statusClass(value) {
      switch (value) {
        case 'A':
          return 'accepted';
        case 'R':
          return 'declined';
        default:
          return 'pending-status';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-section {
  display: flex;
  justify-content: space-between;
}

.select select {
  padding: 8px 12px;
  line-height: 20px !important;
  border-radius: 5px !important;
  color: #202223;
  font-weight: 400;
}
.badge {
  padding: 2px 12px;
  border-radius: 999px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-left: 16px;
  color: #202223;

  &.pending-status {
    background-color: #fff;
  }

  &.accepted {
    background-color: #aee9d1;
  }
  &.declined {
    background-color: #ffd79d;
  }
}
</style>
